import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import { Grid, Card, CardContent, List, ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import StandardDialog from './StandardDialog';
import PersonIcon from '@material-ui/icons/Person';



const validate = values => {
    const error  = {}
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        error.email = 'Correo electrónico no valido'
    }
    if (!values.email) {
        error.email = "El email es un campo obligatorio"
    }
    return error
}

const InternalForm = props => {
    const { handleSubmit, onCancelAction, submitting, pristine, initialValues } = props
    return  <Card  variant="outlined"> 
                <CardContent>
                    <form onSubmit = {handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                
                                <List>
                                    
                                    <ListItem>
                                        <ListItemAvatar>
                                            <PersonIcon />
                                        </ListItemAvatar>
                                        <ListItemText primary={ initialValues.name } secondary={ initialValues.type_name +" - "+initialValues.number } />
                                    </ListItem>
                                            
                                </List>
                                {/* <Field
                                    name="name"
                                    id= "name"
                                    required
                                    // value= {data.number}
                                    // onChange={handleChangeCedule}
                                    component={ RenderTextFieldRedux }
                                    label="Nombre del beneficiario"
                                    type="text"
                                    fullWidth
                                /> */}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Field
                                    name="email"
                                    id= "email"
                                    required
                                    textTransform = "lowercase"
                                    // onChange={handleChangeCedule}
                                    component={ RenderTextFieldRedux }
                                    label="Correo electrónico"
                                    type="text"
                                    fullWidth
                                />
                            </Grid>
                            
                            <br></br>
                            <Grid item xs={6} md={6}>
                                <Button 
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    type="submit" 
                                    disabled={pristine || submitting}
                                >
                                    Guardar
                                </Button>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Button variant="contained" fullWidth onClick = { () => onCancelAction() } style = {{
                                    fontSize: '0.6rem',
                                    color: '#1a1919',
                                    borderLeft: '3px solid rgba(255, 198, 0)',
                                    backgroundColor: "white",
                                    borderRadius: '0px',
                                    fontFamily: 'Ubuntu',
                                    fontWeight: 'bold'
                                }}>Cancelar</Button>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
}

const InternalReduxForm = reduxForm(
    {
      form: 'InternalForm',
      validate,
    }
)(InternalForm)


const BeneficiaryInternalForm = props => {
    const {  onCloseBeneficiaryForm, internalBeneficiary, onAcceptClick } = props
    const {open, data } = internalBeneficiary

    const handleSubmit = (values) => {
        //console.log(values)

        onAcceptClick({
            ...values,
            email : values.email.toLowerCase()
        })
    }
    
    return (
            <StandardDialog
                title = { 'Editar beneficiario'}
                open = {open}
                handleClose = {onCloseBeneficiaryForm}
            >
                <InternalReduxForm
                    onSubmit = { handleSubmit }
                    onCancelAction = {onCloseBeneficiaryForm}
                    // data = {data}
                    initialValues = {data} />
            </StandardDialog>
    );
};

BeneficiaryInternalForm.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default BeneficiaryInternalForm;